import { render, staticRenderFns } from "./LeagueDetails.vue?vue&type=template&id=255a3d8a&scoped=true&"
import script from "./LeagueDetails.vue?vue&type=script&lang=js&"
export * from "./LeagueDetails.vue?vue&type=script&lang=js&"
import style0 from "./LeagueDetails.vue?vue&type=style&index=0&id=255a3d8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a3d8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VImg,VRow,VSimpleTable})
